export const TOGGLE_MESSAGES_FILTER = 'TOGGLE_MESSAGES_FILTER'
export const RESET_MESSAGE_FILTERS = 'RESET_MESSAGE_FILTERS'
export const SET_FILTERED_MESSAGES = 'SET_FILTERED_MESSAGES'
export const SET_MESSAGES_FILTER_TEXT = 'SET_MESSAGES_FILTER_TEXT'

const initialState = {
  filterValue: [],
  filteredMessages: [],
  filterText: '',
}

export default function messageFilters(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_MESSAGES_FILTER: {
      const { filter } = action
      const filterIndex = state.filterValue.indexOf(filter)
      let filterValue = []

      if (filterIndex === -1) {
        filterValue = state.filterValue.concat([filter])
      } else {
        const newFilterValues = [].concat(state.filterValue)
        newFilterValues.splice(filterIndex, 1)
        filterValue = newFilterValues
      }

      return Object.assign({}, state, { filterValue })
    }

    case SET_FILTERED_MESSAGES: {
      const { filteredMessages } = action
      return Object.assign({}, state, { filteredMessages })
    }

    case SET_MESSAGES_FILTER_TEXT: {
      const { filterText } = action
      return Object.assign({}, state, { filterText })
    }

    case RESET_MESSAGE_FILTERS: {
      return initialState
    }

    default: {
      return state
    }
  }
}
